import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54c0c054"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "order-image"
}
const _hoisted_3 = { class: "mt-2 details" }
const _hoisted_4 = { class: "font-weight-bold text-center" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "勤務日時:", -1))
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "info-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "日給（時給）:  ", -1))
const _hoisted_10 = { class: "font-weight-bold" }

import { orderService } from "@/app/services/OrderService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { SlimOrder } from "@/types/order/Order";
import { getOptimizedImageUrl, isDataUri } from "@/utils/image";
import { formatNumber } from "@/utils/number";
import { useCustomRouter } from "@/utils/router";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestOrderModal',
  props: {
  order: {
    type: Object as () => SlimOrder | null,
    default: null
  }
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;




const { pushIgnoreError } = useCustomRouter();

const visible = computed(() => !!props.order);
const workDateTime = computed(() => {
  if (!props.order) return "";
  const order = props.order;
  const date = orderService.getFormattedDateWithSlash(order);

  // workTimeOptionsが空の配列の場合の対応
  if (order.workTimeOptions.length === 0) {
    return `${date}`;
  }

  const timeRange = orderService.getWorkTimeRangeFromSlimOrder(
    order.workTimeOptions[0]
  );
  return `${date} ${timeRange}`;
});

const salaryPerDay = computed(() => {
  if (!props.order) return "";
  const order = props.order;

  if (order.workTimeOptions.length === 0) {
    return "";
  }

  return formatNumber(
    orderService.getSalaryPerDayWithVariousAllowancesFromSlimOrder(
      order,
      order.workTimeOptions[0]
    )
  );
});

const hourlyWage = computed(() => {
  if (!props.order) return "";
  const order = props.order;
  return formatNumber(order.hourlyWage);
});

function getOptimizedOrderImageSmall(image: string | null) {
  if (isDataUri(image)) return image;
  if (!image) {
    return require("@/assets/img/undefined.png");
  }
  return getOptimizedImageUrl(image, 480, null);
}

async function onClickDetail() {
  await pushIgnoreError({
    name: "OrdersDetail",
    params: {
      orderId: props.order?.id
    }
  });
}

function onClickClose() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  const _component_BImgLazy = _resolveComponent("BImgLazy")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    visible: visible.value,
    "hide-footer": "",
    title: "こちらのお仕事はいかがでしょうか？",
    centered: "",
    onClose: onClickClose,
    onHide: onClickClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.order?.image1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_BImgLazy, {
                class: "order-image",
                src: getOptimizedOrderImageSmall(__props.order?.image1)
              }, null, 8, ["src"])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.order?.office.name), 1),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(),
            _createElementVNode("span", _hoisted_7, _toDisplayString(workDateTime.value), 1)
          ]),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(),
            _createElementVNode("span", _hoisted_10, _toDisplayString(salaryPerDay.value) + "円（時給 " + _toDisplayString(hourlyWage.value) + "円）", 1)
          ]),
          _createTextVNode(),
          _createElementVNode("p", null, [
            _createVNode(FeatherIcon, {
              icon: "map-pin",
              size: "14",
              class: "mr-1"
            }),
            _createTextVNode(" " + _toDisplayString(__props.order?.office.address), 1)
          ])
        ]),
        _createTextVNode(),
        _createVNode(AppButton, {
          block: "",
          class: "mt-4",
          onClick: onClickDetail
        }, {
          default: _withCtx(() => [
            _createTextVNode("詳細を確認する")
          ], undefined, true),
          _: 1
        })
      ])
    ], undefined, true),
    _: 1
  }, 8, ["visible"]))
}
}

})